import { ajax } from "../../../../../plugins/api";

export const departments = {
    all: () => ajax.get(`admin/support/departments`),
    get: id => ajax.get(`admin/support/departments/${id}`),
    store: (data, vmId = null, scope = "form") => ajax.post("admin/support/departments", data, vmId, scope),
    update: (id, data, vmId = null, scope = "form") => ajax.put(`admin/support/departments/${id}`, data, vmId, scope),
    destroy: id => ajax.delete(`admin/support/departments/${id}`),
    getMy: () => ajax.get("admin/support/allowed-departments"),
    getAll: () => ajax.get("admin/support/all-departments")
};
